import React from 'react'

class JustComments extends React.Component {
    constructor(...args) {
        super(...args)
        this.ref = React.createRef()
    }
    render() {
        return (
            <div ref={this.ref} className="just-comments" data-apikey="5965ee76-3572-4bb2-b23c-33d7ad9381f5" />
        )
    }
    componentDidMount() {
        const s = document.createElement('script')
        s.src = '//just-comments.com/w2.js'
        s.setAttribute('data-timestamp', +new Date())
        this.ref.current.appendChild(s)
    }
}

export default JustComments